import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { ReportResponse } from '../../../../types/reports';

type CellParams = ICellRendererParams & {
  historyCallback: (element: ReportResponse) => void;
  removeCallback: (element: ReportResponse) => void;
};

@Component({
  selector: 'app-cell-report-dashboard-actions',
  imports: [UiModule, NgSelectModule, FormsModule, RouterLink, SweetAlert2Module],
  templateUrl: './cell-report-dashboard-actions.component.html',
  styleUrl: './cell-report-dashboard-actions.component.scss',
})
export class CellReportDashboardActionsComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
